import MyHoursOverviewPageActionTypes from '../actions/my-hours-overview-page-action-types';

const initialState = {
  selectedTab: 0
};

export default function MyHoursOverviewPageReducer(state = initialState, action) {
  switch (action.type) {
    case MyHoursOverviewPageActionTypes.SELECT_TAB:
      return { ...state, selectedTab: action.payload.selectedTab };
    default:
      return state;
  }
}
